import { useNavigate } from "react-router-dom";

import type { BalanceItem } from "../../types";
import { resolveUrl } from "@/utils/workspace-url";

const BRAND = "#FF6B35";
// 每个菜单项的图标背景色（循环使用）
const ICON_BGS = ["#FFF3EE", "#F0F5FF", "#EDFCF5", "#FEF3FF"];

interface Props {
  title: string;
  list: BalanceItem[];
}

export function CardComp({ title, list }: Props) {
  const navigate = useNavigate();

  if (!list.length) return null;

  return (
    <div className="bg-white rounded-2xl overflow-hidden">
      {/* 标题栏 */}
      <div className="flex items-center px-4 pt-4 pb-3">
        <span
          className="w-[3px] h-[18px] rounded-full mr-2.5"
          style={{ background: BRAND }}
        />
        <span className="text-base font-bold text-gray-900">{title}</span>
      </div>

      {/* 菜单列表 */}
      <div>
        {list.map((item, index) => (
          <button
            key={item.id}
            onClick={() => item.url && navigate(resolveUrl(item.url))}
            className="w-full flex items-center gap-3 px-4 py-3.5 active:bg-gray-50 transition-colors text-left border-t border-gray-50"
          >
            {/* 图标容器 */}
            <div
              className="w-9 h-9 rounded-xl flex items-center justify-center shrink-0"
              style={{ background: `${ICON_BGS[index % ICON_BGS.length]}20` }}
            >
              {item.pic ? (
                // eslint-disable-next-line @next/next/no-img-element
                <img src={item.pic} alt="" className="w-5 h-5 object-contain" />
              ) : (
                <i className="ri-arrow-right-s-line text-base" style={{ color: BRAND }} />
              )}
            </div>

            <span className="text-sm font-medium text-gray-800 flex-1">{item.name}</span>

            <i className="ri-arrow-right-s-line text-gray-300" />
          </button>
        ))}
      </div>
    </div>
  );
}
